import { format, parseISO } from "date-fns";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";

export function TemplateDateCell({ value }: { value: Date | string | null }) {
    if (!value) {
        return (
            <ViewTableCell>
                <span className="text-muted">-</span>
            </ViewTableCell>
        );
    }
    const date = value instanceof Date ? value : parseISO(value);
    const label = Number.isNaN(date.getTime())
        ? ""
        : format(date, "MMM d, yyyy");

    return <ViewTableCell>{label}</ViewTableCell>;
}
